// reduxjs toolkit
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleSuccess, handleError } from "../../utils/toast";

const handleApiResponse = (response, thunkAPI, successMessage) => {
  if (response.status === 200 || response.status === 201) {
    if (successMessage) handleSuccess(successMessage);
    return response.data;
  } else {
    handleError(response.message);
    return thunkAPI.rejectWithValue(response.data);
  }
};

const handleApiError = (error, thunkAPI, errorMessage) => {
  handleError(error.response?.data?.message || errorMessage);
  return thunkAPI.rejectWithValue(error.response?.data);
};

// List all News
export const viewNews = createAsyncThunk("blogs", async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${BaseUrl}backend-api/blogs/data`);
    return handleApiResponse(response, thunkAPI);
  } catch (e) {
    return handleApiError(e, thunkAPI, "loading...");
  }
});

// Add new blogs
export const registerNews = createAsyncThunk(
  "blogs",
  async (blogsData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BaseUrl}backend-api/blogs`,
        blogsData,
      );

      return handleApiResponse(response, thunkAPI, "Register successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);

// Search News by ID
export const singleNews = createAsyncThunk("blogs", async (id, thunkAPI) => {
  try {
    const response = await axios.get(`${BaseUrl}backend-api/blogs/${id}`);
    return handleApiResponse(response, thunkAPI);
  } catch (e) {
    return handleApiError(e, thunkAPI, "search maintenance history...");
  }
});

// Update News
export const updateNews = createAsyncThunk(
  "blogs",
  async ({ id, formData }, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BaseUrl}backend-api/blogs/${id}`,
        formData,
      );
      return handleApiResponse(response, thunkAPI, "Change saved successfully");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);

// Delete News
export const deleteNews = createAsyncThunk("blogs", async (id, thunkAPI) => {
  const token = JSON.parse(localStorage.getItem("userInfo")) || null;
  try {
    const response = await axios.delete(`${BaseUrl}backend-api/blogs/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return handleApiResponse(response, thunkAPI, "Delete successful!");
  } catch (e) {
    return handleApiError(e, thunkAPI);
  }
});
